module.exports = __webpack_public_path__ + "img/4.628cf8a1.png";